{
  "#BUCHUNGSBRIEF": {
    "TITLE": "Buchungsbrief",
    "PAGE": {
      "BELEGDATEN": "Belegdaten",
      "BELEGART": "Belegart",
      "RECHNUNGSNUMMER": "StreckenNr.",
      "FREMDBELEGSNUMMER": "FremdbelegNr.",
      "BELEGDATUM": "Belegdatum",
      "KUNDE": "Lieferant",
      "NETTO": "Nettobetrag",
      "BRUTTO": "Bruttobetrag",
      "FORM": "Formular",
      "BUCHUNGSBRIEF": "Buchungsbrief",
      "NACHZAHLUNG": "Nachzahlung",
      "BEGRUENDUNG": "Begründung",
      "NETTOWERT": "Nettowert",
      "FORM_UST": "UST %",
      "FORM_NETTO": "Nettobetrag in EUR",
      "BETRAG": "Betrag",
      "UST": "USt.",
      "EDIT_PDF": "Bearbeiten",
      "RESET_PDF": "Zurücksetzen",
      "INFO_TITLE": "Information",
      "INFO_TEXT": "Der hochgeladene Anhang sowie der bearbeitete Ursprungsbeleg werden der Korrektur angehängt.",
      "NO_DOCUMENT": "Kein Beleg im Archiv",
      "NO_DOCUMENT_DESCRIPTION": "Zu diesem Beleg ist kein archiviertes PDF vorhanden.",
      "SUBMIT": "Speichern"
    },
    "ADD_ON": {
      "TITLE": "Korrektur"
    },
    "DIALOGS": {
      "CONFIRM": "Möchten Sie die Korrektur erstellen?"
    },
    "MESSAGES": {
      "SUCCESS": {
        "CREATED": "Der Buchungsbrief wurde erstellt"
      }
    },
    "VALIDATION": {
      "ERRORS": {
        "MAX_FILES": {
          "SUBJECT": "Es können nicht mehr als 10 Dateien hochgeladen werden!"
        }
      }
    }
  }
}
